import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
/**
 * @file backoff
 * @date 2021-07-03
 */

import Backoff from 'backo2';
export var cache = {};
export var timeout = function timeout(key) {
  if (!cache[key]) return;
  cache[key].$timer = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (cache[key]) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          _context.next = 4;
          return cache[key].$callback();
        case 4:
          if (cache[key]) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return");
        case 6:
          if (cache[key].$maxCount === 0 || cache[key].attempts <= cache[key].$maxCount) timeout(key);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), cache[key].duration());
};
export var createBackoff = function createBackoff(key) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (cache[key]) return cache[key];
  var maxCount = options.maxCount || 0;
  var callback = typeof options.callback === 'function' ? options.callback : function () {};
  delete options.maxCount;
  delete options.callback;
  cache[key] = new Backoff(options);
  cache[key].$maxCount = maxCount;
  cache[key].$callback = callback;
  timeout(key);
  return cache[key];
};
export var getBackoff = function getBackoff(key) {
  return cache[key] || null;
};
export var removeBackoff = function removeBackoff(key) {
  if (!cache[key]) return;
  clearTimeout(cache[key].$timer);
  delete cache[key];
};